import React from 'react';
import NotAuthorized from '../views/pages/NotAuthorized';
import CryptoJS from 'crypto-js';
import { Navigate } from 'react-router-dom'
const AuthCheckStudent = ({ children }) => {
  const encryptedUserData = window.localStorage.getItem('userData');
  const secretKey = 'sffs-secret-2025';

  if (!encryptedUserData) {
    return <Navigate to="/login" replace />;
  }

  const decryptedUserDataBytes = CryptoJS.AES.decrypt(encryptedUserData, secretKey);
  const decryptedUserData = JSON.parse(decryptedUserDataBytes.toString(CryptoJS.enc.Utf8));
  const userRole = decryptedUserData.role;

  const allowedRoles = ['STUDENT'];

  if (allowedRoles.includes(userRole)) {
    return children;
  }

  return <NotAuthorized />;
};

export default AuthCheckStudent;
